<script>
  import { onMount, tick } from 'svelte'

  import { fldvalselected,
           formfldvalselected,
           errfldvalselected,
           errfrmvalselected,
           focuscontainerid,
           pagectxstate,
           currentformid,
           user } from './stores'

  import FormFieldTable,
         { isRowMatch as isFldRowMatch } from './FormFieldTable.svelte'

  import FormTable,
         { isRowMatch as isFrmRowMatch } from './FormTable.svelte'

  import { showPage, getApiUrl, fetchWithSession } from './util'

  let fielderrors
  let formerrors

  let fldapiErrorMessage
  let frmapiErrorMessage

  let mounted
  let isLoading = false

  // Managing pagectx and session store for data not in query string:
  //   On row select, update store.  Store triggers pagectx update.
  //   On mount with non-null pagectx data, set store, set app.
  //   On mount with null pagectx data and non-null store,
  //        set pagectx and app.
  //   On mount with null pagectx data and null store, set app
  //        based on default (e.g., select first row).
  // For URL query-string data, some of the above should still
  // apply with the query string taking the place of pagectx.

  let selectedFrmRow = null
  $: { storeSelectedFrmRow(selectedFrmRow) }
  function storeSelectedFrmRow(r) {
    console.log('storeSelectedFrmRow')
    if (r && $errfrmvalselected !== r) {
      $errfrmvalselected = r
      if ($currentformid !== r.formid) {
        // TODO: Look at how we are using $currentformid.
        $currentformid = r.formid
      }
    }
  }

  let selectedFldRow = null
  $: { storeSelectedFldRow(selectedFldRow) }
  function storeSelectedFldRow(r) {
    console.log('storeSelectedFldRow')
    if (r && $errfldvalselected !== r) {
      $errfldvalselected = r
      if ($currentformid !== r.formid) {
        // TODO: Look at how we are using $currentformid.
        $currentformid = r.formid
      }
    }
  }


  $: { updatePageCtxFromStore($errfldvalselected,
                              $errfrmvalselected,
                              $focuscontainerid) }
  function updatePageCtxFromStore(vfld, vfrm, focid) {
    if (mounted) {
      if (vfld !== $pagectxstate.errfldvalselected ||
          vfrm !== $pagectxstate.errfrmvalselected ||
          focid !== $pagectxstate.focuscontainerid) {
        $pagectxstate.errfldvalselected = vfld
        $pagectxstate.errfrmvalselected = vfrm
        $pagectxstate.focuscontainerid = focid
      }
    }
  }


  // querycontrolList and sourceList provide filter values for the
  // field errors table.  Had similar for subject but trying
  // something different now for that.
  let querycontrolList = []
  let sourceList = []
  $: {  console.log(fielderrors)
        if (fielderrors) {
          // TODO: Build sets in single loop.
          querycontrolList = [...new Set(fielderrors.map(r => r.querycontrol))]
          sourceList = [...new Set(fielderrors.map(r => r.sourcename))].sort()
        } else {
          querycontrolList = []
          sourceList = []
        }
     }

  async function loadFieldErrors() {
    const apiurl = getApiUrl('fields/errors/current')
    let res
    console.log('loadFieldErrors...')
    try {
      res = await fetchWithSession(apiurl, {cache: 'no-store'})
    } catch (err) {
      console.log(err)
    }
    if (res?.ok) {
      fldapiErrorMessage = null
      const json = await res.json()
      console.dir(json)
      fielderrors = json
      // Keep only queries for 'complete' forms
      fielderrors = fielderrors.filter(e => e.sourcestatus === 'complete')
      selectFldRowFromStore()
    } else {
      fldapiErrorMessage = 'Error using API to get field errors'
      fielderrors = null
      console.dir(res)
      res?.text().then(t => console.log(t))
    }
  }

  async function loadFormErrors() {
    const apiurl = getApiUrl('forms/errors/current')
    let res
    isLoading = true
    console.log('loadFormErrors...')
    try {
      res = await fetchWithSession(apiurl, { cache: 'no-store' })
      console.log('loadFormErrors: res: ', res)
    } catch (err) {
      console.log("Error using API to get form errors: ", err)
      console.log(err)
    }
    if (res?.ok) {
      frmapiErrorMessage = null
      const json = await res.json()
      console.dir(json)
      formerrors = json
      console.log('formerrors: ', formerrors)
      selectFrmRowFromStore()
    } else {
      frmapiErrorMessage = 'Error using API to get form errors'
      formerrors = null
      console.error(frmapiErrorMessage)
      console.dir(res)
      res?.text().then(t => console.log(t))
    }
    isLoading = false
  }

  async function selectFldRowFromStore() {
    let found = fielderrors.find(
                  v => isFldRowMatch(v, $errfldvalselected))

    if (!found && fielderrors.length > 0) {
      found = fielderrors[0]
    }
    if (found) {
      selectedFldRow = found
    }
  }

  async function selectFrmRowFromStore() {
    let found = formerrors.find(
                  v => isFrmRowMatch(v, $errfrmvalselected))

    if (!found && formerrors.length > 0) {
      found = formerrors[0]
    }
    if (found) {
      selectedFrmRow = found
    }
  }


  async function refocusRow() {
    await tick()
    const focuscontainer = document.getElementById($focuscontainerid)
    focuscontainer?.querySelector('.selected')?.focus()
  }


  onMount( () => {
    mounted = true
    console.log('onMount ErrorPage')
    if (!$user.isAuth) {
      console.error('onMount ErrorPage 1')
      return
    }

    console.error('onMount ErrorPage 2')

    if ($pagectxstate.errfldvalselected) {
      $errfldvalselected = $pagectxstate.errfldvalselected
    } else if ($errfldvalselected) {
      $pagectxstate.errfldvalselected = $errfldvalselected
    }
    if ($pagectxstate.errfrmvalselected) {
      $errfrmvalselected = $pagectxstate.errfrmvalselected
    } else if ($errfrmvalselected) {
      $pagectxstate.errfrmvalselected = $errfrmvalselected
    }
    if ($pagectxstate.focuscontainerid) {
      $focuscontainerid = $pagectxstate.focuscontainerid
    } else if ($focuscontainerid) {
      $pagectxstate.focuscontainerid = $focuscontainerid
    }

    console.error('onMount ErrorPage 3')


    Promise.allSettled([
      loadFieldErrors(),
      loadFormErrors()
    ]).then( () => refocusRow() )

    console.error('onMount ErrorPage 4')

  })


  function handleFocusin(e) {
    const currtargid = e.currentTarget.id
    if (currtargid !== $focuscontainerid) {
      $focuscontainerid = currtargid
    }
  }


  async function handleFldRowKeydown(e) {
    const { row, key, isRowSelected } = e.detail

    if (isRowSelected) {
      switch (key) {
        case 'f':
          // Set up for desired fldval row selection.
          $fldvalselected = { formid: row.formid,
                              formfieldid: row.formfieldid }
          await tick()
          showPage('/fldvals', { subject: row.subject,
                                 field: row.fieldname })
          break;
        case 'F':
          $formfldvalselected = { formid: row.formid,
                                  formfieldid: row.formfieldid }
          await tick()
          showPage('/form', { frm: row.formid })
          break;
        case 'p':
          showPage('/subj', { subject: row.subject })
          break;
      }
    }
  }


  async function handleFrmRowKeydown(e) {
    const { row, key, isRowSelected } = e.detail
    if (isRowSelected) {
      switch (key) {
        case 'F':
          $formfldvalselected = { formid: null,
                                  formfieldid: null }
          await tick()
          showPage('/form', { frm: row.formid })
          break;
        case 'p':
          showPage('/subj', { subject: row.subject })
          break;
      }
    }
  }

  
  $: activefldcols = [
    'sourcename',
    'shortformname',
    'subject',
    'formid',
    'repeatinstance',
    'formfieldid',
    'formfieldvalueid',
    'fieldname',
    'alias',
    'sitecode',
    'kstr',
    'querycontrol',
    'errortext',
  ]

  let selectedFieldColumns = {
    // sourcename:true,
    shortformname:true,
    subject:true,
    formid:true,
    repeatinstance:true,
    formfieldid:true,
    formfieldvalueid:false,
    fieldname:true,
    alias:false,
    sitecode:false,
    kstr:true,
    errortext:true,
    // querycontrol:true,
  };
  
  const toggleFieldColumn = (key) => {
    console.log('toggleFieldColumn', key);
    console.log(selectedFieldColumns[key]);
    // print the value of all keys in the object
    for (const [key, value] of Object.entries(selectedFieldColumns)) {
      console.log(`${key}: ${value}`);
    }
    selectedFieldColumns[key] = !selectedFieldColumns[key]
  }

  $: fldcolumns = activefldcols.filter(f => {
        // Display sitecode only if at least one value present.
        if (f === 'sitecode' &&
            (!fielderrors || !fielderrors.some(fe => f.sitecode))) {
          return false
        }
        return true
      }).map(f => availfldcols[f])
      .filter((col) => (col.key in selectedFieldColumns ? selectedFieldColumns[col.key] : true));
  // filterOptions can take an array of values that will
  // be used for both name and value.
  $: availfldcols = {
      subject: { key: 'subject',
        title: 'Subject',
        value: v=>v.subject,
        sortable: true,
        //filterOptions: rows => [...new Set(rows.map(r => r.subject))].sort().map(v => ({name:v, value:v}))
        searchValue: v=>v.subject,
        class: 'subject' },
      sourcename: { key: 'sourcename',
        title: 'Source',
        value: v=>v.sourcename ?? '',
        sortable: true,
        filterOptions: sourceList,
        class: 'sourcename' },
      formid: { key: 'formid',
        title: 'Form',
        value: v=>v.formid,
        sortable: true,
        class: 'formid',
        searchValue: v=>v.formid },
      repeatinstance: { key: 'repeatinstance',
        title: 'Instance',
        value: v=>v.repeatinstance ?? '',
        sortable: true,
        class: 'repeatinstance'},
      shortformname: { key: 'shortformname',
        title: 'Form name',
        value: v=>v.shortformname ?? '',
        sortable: true,
        searchValue: v=>v.shortformname,
        class: 'shortformname' },
      formfieldid: { key: 'formfieldid',
        title: 'Field ID',
        value: v=>v.formfieldid,
        sortable: true,
        class: 'formfieldid' },
      formfieldvalueid: { key: 'formfieldvalueid',
        title: 'Value ID',
        value: v=>v.formfieldvalueid,
        sortable: true,
        class: 'formfieldvalueid' },
      fieldname: { key: 'fieldname',
        title: 'Field name',
        value: v=>v.fieldname,
        sortable: true,
        searchValue: v=>v.fieldname,
        class: 'fieldname' },
      alias: { key: 'alias',
        title: 'Alias',
        value: v=>v.alias ?? '',
        sortable: true },
      sitecode: { key: 'sitecode',
        title: 'Site code',
        value: v=>v.sitecode ?? '',
        sortable: true },
      kstr: { key: 'kstr',
        title: 'Value entered',
        value: v=>v.kstr ?? '',
        sortable: true,
        class: 'kstr' },
      errortext: { key: 'errortext',
        title: 'Error',
        value: v=>v.errortext ?? '',
        sortable: true,
        class: 'errortext' },
      querycontrol: { key: 'querycontrol',
        title: 'Query control',
        value: v=>v.querycontrol ?? '',
        sortable: true,
        filterOptions: querycontrolList,
        class: 'querycontrol' },
    }


  const frmcolumns = [
      { key: 'subject',
        title: 'ID',
        value: v=>v.subject,
        sortable: true,
        class: 'subject' },
      { key: 'shortformname',
        title: 'Form name',
        value: v=>v.shortformname,
        sortable: true },
      { key: 'inforeqstatus',
        title: 'Info req status',
        value: v=>v.inforeqstatus ?? '',
        sortable: true },
      { key: 'inforeqtext',
        title: 'Info req text',
        value: v=>v.inforeqtext ?? '',
        sortable: true },
      //{ key: 'errortype',
      //  title: 'Error type',
      //  value: v=>v.errortype ?? '',
      //  sortable: true },
      //{ key: 'querycontrol',
      //  title: 'Query control',
      //  value: v=>v.querycontrol ?? '',
      //  sortable: true }
    ]


</script>

{#if $user.isAuth}

  <div class="hotkeys">
    Select a row and use the following keys to navigate:
    <span class="key">f</span>: <b>field value</b> &nbsp;
    <span class="key">F</span>: <b>form</b> &nbsp;
    <span class="key">p</span>: list of forms for the <b>participant</b>
  </div>
  {#if isLoading}
  <div class="loading">
    <div class="spinner" />
  </div>
{:else}
  <h3>Form-level errors and information requests</h3>
  {#if fldapiErrorMessage}
    <div>{fldapiErrorMessage}</div>
  {/if}
  {#if formerrors}
    <div id="frmtablewrap" on:focusin={handleFocusin}>
      <FormTable
        rows={formerrors}
        columns={frmcolumns}
        bind:selectedRow={selectedFrmRow}
        on:rowkeydown={handleFrmRowKeydown} />
    </div>
  {/if}
  <br />
  <hr />
  <h3>Field-level errors</h3>
  {#if frmapiErrorMessage}
    <div>{frmapiErrorMessage}</div>
  {/if}
  {#if fielderrors}
    <h4>Select columns to display:</h4>
    <div class="field-column-select">
      {#each Object.entries(selectedFieldColumns) as [key, column]}
        <label>
          <input
            type="checkbox"
            checked={selectedFieldColumns[key]}
            on:change={() => toggleFieldColumn(key)} />
          {availfldcols[key].title}
        </label>
      {/each}
    </div>
    <div class="fldtablewrap" on:focusin={handleFocusin}>
      <FormFieldTable
        rows={fielderrors}
        columns={fldcolumns}
        on:rowkeydown={handleFldRowKeydown} />
    </div>
  {/if}
{/if}
{:else}
  <div class="not-authorized">
    <p>You are not authorized to view this page.</p>
  </div>
{/if}

<style>
  h3 {
    margin: 1em 0 .5em 0;
  }
  .fldtablewrap :global(td.subject) {
    width: 8em;
  }
  .fldtablewrap :global(td.fieldname) {
    width: 7em;
  }
  .fldtablewrap :global(td.kstr) {
    overflow-wrap: break-word;
    width: 12em;
  }
  .fldtablewrap :global(td.sourcename) {
    width: 12em;
  }
  .fldtablewrap :global(td.formid) {
    width: 3em;
  }
  .fldtablewrap :global(td.repeatinstance) {
    width: 1em;
  }
  .fldtablewrap :global(td.kstr) {
    width: 1em;
  }
  .fldtablewrap :global(td.shortformname) {
    width: 12em;
  }
  .fldtablewrap :global(td.querycontrol) {
    width: 5em;
  }
  h4 {
    margin: 0.5em 0;
  }
  .field-column-select {
    margin-bottom: 0.5em;
  }
  .field-column-select label {
    margin: 0;
    margin-right: 1em;
  }
  .hotkeys {
    background-color: #f7f7f7;
    padding: 1em;
    border-radius: 4px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .key{
    padding: 0.3em 0.5em;
    background-color: #fff;
    font-family: monospace;
    border-radius: 4px;
    border: 1px solid #ccc;
    margin: 0.5em 0.5em;
    font-weight: bold;
  }
  .spinner{
    width: 20px;
    height: 20px;
    margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30%;
  }
  .not-authorized{
    text-align: center;
    margin-top: 20%;
    font-size: 1.2em;
  }
</style>

